import React from 'react';

import { Switch, useHistory } from "react-router-dom";
import style from './AdminRoom.module.css'


import { PictureIcon } from '../../../../../assets/icons';
import { RouteWithSubRoutes } from '../../../../../config/Router';
import { Translate } from '../../../../../language';
import Button from '../../../../../utils/components/Button/Button';
import localStorage from '../../../../../utils/hooks/useLocalStorage';

const AdminRoomRoot = ({ roomInfo, routes, isAdmin }) => {
  const history = useHistory()
  if (!roomInfo._id) {
    return (
      <div className={style.content_error}>
        <div className="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
      </div>
    )
  }
  else
    return (
      <div className={style.content_general}>
        <div className={style.content_left}>
          <div className={style.content_icon}><PictureIcon className={style.icon} /></div>
          <div className={style.content_list_rooms}>
            <div className={style.title}>
              {Translate('adminchatRoom', 'es')}

            </div>
            <div className={style.roomInfo}>
              <div className={style.create}>
                <div className={style.green}>{roomInfo.name}</div>
              </div>
              <div className={style.roomInfo}>
                <div>{Translate('category', 'es')}</div>
                <div className={style.purple}> {roomInfo.chatCategoriesID?.name}</div>
              </div>
              <div>
                {
                  roomInfo.privacity === 0 ? Translate('public_f', 'es') : Translate('private_f', 'es')
                }
              </div>
            </div>
            <Button onClick={(e) => {
              e.preventDefault(); e.stopPropagation();
              history.push(`/Rooms/Admin/${roomInfo._id}`)
            }} text={'General'} classNameContent={style.content_button} theme={'white'} />

            <Button onClick={(e) => {
              e.preventDefault(); e.stopPropagation();
              history.push(`/Rooms/Admin/${roomInfo._id}/Members`)
            }} text={'Miembros'} classNameContent={style.content_button} theme={'white'} />
            {isAdmin && (
              <>
                <Button onClick={(e) => {
                  e.preventDefault(); e.stopPropagation();
                  history.push(`/Rooms/Admin/${roomInfo._id}/Invite`)
                }} text={'Invitar'} classNameContent={style.content_button} theme={'white'} />
                {
                  roomInfo.privacity === 1 && <Button onClick={(e) => {
                    e.preventDefault(e); e.stopPropagation();
                    history.push(`/Rooms/Admin/${roomInfo._id}/Requests`)
                  }} text={'Solicitudes'} classNameContent={style.content_button} theme={'white'} />
                }
                <Button onClick={(e) => {
                  e.preventDefault(); e.stopPropagation();
                  history.push(`/Rooms/Admin/${roomInfo._id}/Reports`)
                }} text={'Reportes'} classNameContent={style.content_button} theme={'white'} />

                <Button onClick={(e) => {
                  e.preventDefault(); e.stopPropagation();
                  history.push(`/Rooms/Admin/${roomInfo._id}/Delete`)
                }} text={'Borrar sala'} classNameContent={style.content_button} theme={'white'} />
              </>
            )}


          </div>
        </div>
        <div className={style.content_right}>
          <Switch>
            {routes.map((route, i) => (
              <RouteWithSubRoutes key={i} {...route} />
            ))}
          </Switch>
        </div>
      </div>
    );
};

export default AdminRoomRoot;
